var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"tracking-container"},[_c('Tracking',{attrs:{"isDashboard":false,"isSubscribed":_vm.isSubscribed}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }